









import {
  Component, Emit, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class AppToolbar extends Vue {
  @Prop({ required: false })
  private color?: string;

  @Prop({ required: false, default: 'large' })
  private size?: 'large';

  @Prop({ required: false, default: 'light' })
  private theme?: 'dark' | 'light';

  get classList(): string {
    return `
      c-btn
      c-btn--${this.size}
      c-btn--${this.theme}
      ${this.color}
    `;
  }

  @Emit('click')
  click(e: Event) {
    return e;
  }
}
